import { SingleServiceCenter } from "api"
import { useIsDesktop } from "common/MediaQueries"
import { useState } from "react"
import FormErrorState from "reusable/formsComp/FormErrorState"
import FormSuccessState from "reusable/formsComp/FormSuccessState"
import ClassicPopUp from "reusable/popups/ClassicPopUp"
import styled from "styled-components"
import ContentUsForm from "../forms/ContentUsForm"
import PopUpHeaderUi from "./PopUpHeaderUi"

const StyledWrapper = styled.div`
  text-align: center;
  overflow: auto;
  margin-top: -15px;
`
const StyledWrapperForm = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
`
type ContentUsPopupProps = {
  onClose: () => void
  open: boolean
  centerData: SingleServiceCenter
}
export enum FormStatus {
  Normal = "normal",
  Success = "success",
  Error = "error",
}
const ContentUsPopup = ({ onClose, open, centerData }: ContentUsPopupProps) => {
  const [formStatus, setFormStatus] = useState<FormStatus>(FormStatus.Normal)
  const isDesktop = useIsDesktop()
  return (
    <ClassicPopUp
      open={open}
      onClose={onClose}
      title={centerData.name}
      padding={isDesktop ? "20px" : "0px"}
      arialabelledby="חלונית קביעת תור"
    >
      <StyledWrapper>
        {formStatus === FormStatus.Normal && (
          <PopUpHeaderUi centerData={centerData} type="יצירת קשר" />
        )}
        <StyledWrapperForm>
          {formStatus === FormStatus.Normal && (
            <ContentUsForm
              centerData={centerData}
              setFormStatus={setFormStatus}
            />
          )}

          {formStatus === FormStatus.Error && <FormErrorState />}
          {formStatus === FormStatus.Success && <FormSuccessState />}
        </StyledWrapperForm>
      </StyledWrapper>
    </ClassicPopUp>
  )
}

export default ContentUsPopup
